import { useNavigate } from 'react-router-dom';

import { GenericButton } from '@shared/components/ui/custom';

export const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center px-4 py-16 text-center">
      <h1 className="text-9xl font-extrabold tracking-tight text-muted-foreground/20">403</h1>
      <h2 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">Access Denied</h2>
      <p className="mt-6 text-base leading-7 text-muted-foreground">
        You don&apos;t have permission to access this resource.
      </p>
      <p className="mt-2 text-sm text-muted-foreground">
        If you believe this is an error, please contact your administrator.
      </p>
      <div className="mt-10 flex gap-4">
        <GenericButton
          onClick={() => navigate(-1)}
          variant={'outline'}
          label="Go Back"
          data-testid="unauthorized-back-btn"
        />
        <GenericButton
          onClick={() => navigate('/')}
          variant={'default'}
          label="Back to Home"
          data-testid="unauthorized-home-btn"
        />
      </div>
    </div>
  );
};
